import angular from 'angular';

export default angular.module('app.components.validators.mac', [])

	.directive('mac', function(){
		return {
			require: 'ngModel',
			link: function(scope, elm, attrs, ctrl){

				//const patt = /[^:^\w^]|[G-Z]/g;
				const patt = /[A-F,0-9]{12}/;

				ctrl.$validators.mac = function(modelValue, viewValue){


					if( ctrl.$isEmpty(modelValue) ){
						// consider empty models to be invalid
						return false;
					}

					let val = modelValue ? modelValue.slice(0, 17) : '';
					val = val.toUpperCase();


					return patt.test(val);

				};
			}
		};
	})
	.name;




/** WEBPACK FOOTER **
 ** ./src/components/formValidators/mac.directive.js
 **/